import React from 'react';
import { Box, Dialog, IconButton, SxProps } from '@mui/material';
import { Colors } from '../../../utils/theme';
import { Close } from '@mui/icons-material';
interface IProps {
  id: string;
  title?: string;
  width: number;
  height?: number;
  children: React.ReactNode;
  onClose?: (args: any) => void;
  childrenSx?: SxProps;
  hideTitle?: boolean;
}

const DialogBox: React.FunctionComponent<IProps> = ({
  id,
  title = '',
  width,
  height,
  children,
  onClose,
  childrenSx,
  hideTitle
}) => {
  return (
    <Dialog
      id={`${id}-dialog`}
      open={true}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
          display: 'flex'
        }
      }}
      PaperProps={{
        sx: {
          m: 0,
          maxWidth: `${width}px`,
          width: `${width}px`,
          ...(height && { height })
        }
      }}
      BackdropProps={{ sx: { background: Colors.modalBackground } }}
      onClose={hideTitle ? onClose : undefined}
    >
      {!hideTitle && (
        <Box
          id={`${id}-dialog-title`}
          className="centralize"
          sx={{
            borderBottom: `1px solid ${Colors.skyBlue}`,
            color: Colors.skyBlue,
            fontSize: '22px',
            fontWeight: 'bold',
            minHeight: '62px'
          }}
        >
          {title}
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: '15px',
                top: '18px',
                color: (theme) => theme.palette.primary.main,
                boxShadow: (theme) => `0px 0px 5px ${theme.palette.primary.main}`
              }}
            >
              <Close sx={{ width: 10, height: 10 }} />
            </IconButton>
          ) : null}
        </Box>
      )}
      <Box sx={childrenSx}>{children}</Box>
    </Dialog>
  );
};

export default DialogBox;
